import { createContext, type ReactNode, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { TaskListReducer } from "../reducers/taskListReducer";

const TaskListContext = createContext({
	state: TaskListReducer.getInitialState(),
	actions: TaskListReducer.actions,
});

export const useTaskListContext = () => useContext(TaskListContext);

export const TaskListProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: TaskListReducer.getInitialState(),
		reducers: TaskListReducer.caseReducers,
	});

	return (
		<TaskListContext.Provider value={{ state, actions }}>
			{children}
		</TaskListContext.Provider>
	);
};
